import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClosedByteChannelExceptionClass;
function ClosedByteChannelException() {
  if (ClosedByteChannelExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(cause) {
        return new.target.a4n(cause);
      }
      static a4n(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.j4l(cause == null ? null : cause.message, cause);
        captureStack($this, $this.z4m_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedByteChannelException', $.a4n);
    ClosedByteChannelExceptionClass = $;
  }
  return ClosedByteChannelExceptionClass;
}
var ClosedReadChannelExceptionClass;
function ClosedReadChannelException() {
  if (ClosedReadChannelExceptionClass === VOID) {
    class $ extends ClosedByteChannelException() {
      constructor(cause) {
        return new.target.p4m(cause);
      }
      static p4m(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.a4n(cause);
        captureStack($this, $this.o4m_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedReadChannelException', $.p4m);
    ClosedReadChannelExceptionClass = $;
  }
  return ClosedReadChannelExceptionClass;
}
var ClosedWriteChannelExceptionClass;
function ClosedWriteChannelException() {
  if (ClosedWriteChannelExceptionClass === VOID) {
    class $ extends ClosedByteChannelException() {
      constructor(cause) {
        return new.target.v4m(cause);
      }
      static v4m(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.a4n(cause);
        captureStack($this, $this.u4m_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedWriteChannelException', $.v4m);
    ClosedWriteChannelExceptionClass = $;
  }
  return ClosedWriteChannelExceptionClass;
}
//region block: exports
export {
  ClosedByteChannelException as ClosedByteChannelException3il8gfpye60w,
  ClosedReadChannelException as ClosedReadChannelException9jdpzh6uy12w,
  ClosedWriteChannelException as ClosedWriteChannelException1eeenxj0c4bxu,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
